export default {
  ID_EMPRESA: 1
};
